import React from 'react';
import { addQueryParams } from '@perch-labs/warbler';
import { Card, CopyButton, Text } from '@perch-labs/shrike';
import { Container } from 'styles';
import { copyFor } from 'config';
import { ErrorModule } from 'components/errors';
import { useReferralData } from 'hooks/use-referral-data.hook';
import { LinkBackdrop, LinkText } from './referrals.style';

const getCopy = copyFor('referrals');

export const Referrals = () => {
  const { data, error } = useReferralData();
  const { excludeSavingsLanguage, shareableReferralCode } = data || {};

  const title = excludeSavingsLanguage
    ? getCopy('impact.title')
    : getCopy('savings.title');

  if (error) return <ErrorModule title={title} data-testid="referral-error" />;

  const referralLink = addQueryParams(
    `${process.env.ARCADIA_WEBSITE_URL}/referral`,
    {
      promo: shareableReferralCode,
    }
  );

  return (
    <Card mobileVariant="flat" margin={{ bottom: '24px' }}>
      <Card.Header>
        <Text tag="h2" textStyle="heading700" margin={{ bottom: '8px' }}>
          {title}
        </Text>
      </Card.Header>
      <Card.Content>
        <Text margin={{ bottom: '32px' }}>
          {excludeSavingsLanguage
            ? getCopy('impact.subtitle')
            : getCopy('savings.subtitle')}
        </Text>
        <Text textStyle="heading500" tag="h3" margin={{ bottom: '16px' }}>
          {getCopy('linkHeader')}
        </Text>
        <LinkBackdrop flex justifyContent="space-between" alignItems="center">
          <LinkText className="notranslate">{referralLink}</LinkText>
          <Container>
            <CopyButton
              aria-label={getCopy('copyAriaLabel')}
              copyText={referralLink}
              backgroundless
              size="small"
            />
          </Container>
        </LinkBackdrop>
      </Card.Content>
    </Card>
  );
};
